function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-svg-class": "RoomButton-stroke"
}, /*#__PURE__*/React.createElement("g", {
  "data-svg-class": "RoomButton-fill",
  fillRule: "evenodd",
  fill: "#2B415E",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("rect", {
  width: 69,
  height: 114,
  x: 0.5,
  y: 0.5,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.987 48.5h26.026c4.703-4.151 7.487-10.329 7.487-17 0-6.671-2.784-12.849-7.487-17H21.987c-4.703 4.151-7.487 10.329-7.487 17 0 6.671 2.784 12.849 7.487 17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 22.5h3v11h-3zM40.5 23.5h3v9h-3zM21.987 101.5h26.026c4.703-4.151 7.487-10.329 7.487-17 0-6.671-2.784-12.849-7.487-17H21.987c-4.703 4.151-7.487 10.329-7.487 17 0 6.671 2.784 12.849 7.487 17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.5 75.5h3v11h-3zM40.5 76.5h3v9h-3zM37.5 95.5v-2.3c0-1.498-1.127-2.7-2.5-2.7s-2.5 1.202-2.5 2.7v2.3h5zm0-53v-2.3c0-1.498-1.127-2.7-2.5-2.7s-2.5 1.202-2.5 2.7v2.3h5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 58,
  r: 3.5
})));

function SvgRoomElectricityOutletLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 115,
    viewBox: "0 0 70 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityOutletLarge);
export default __webpack_public_path__ + "static/media/RoomElectricityOutletLarge.66dbed60.svg";
export { ForwardRef as ReactComponent };